import { NgModule } from '@angular/core';

import { FavoritesPageRoutingModule } from './favorites-routing.module';

import { FavoritesPage } from './favorites.page';
import { SharedModule } from '../shared-module/shared.module';

@NgModule({
  imports: [
    SharedModule,
    FavoritesPageRoutingModule
  ],
  declarations: [FavoritesPage]
})
export class FavoritesPageModule {}
